export type SmsType = "direct" | "text2speech";
export type Encoding = "gsm7" | "unicode";

// REQ-GEN-002..008: all persisted user configuration.
export interface LoxSettings {
  apiKey: string; // X-LOX24-AUTH-TOKEN value ("clientId:token")
  senderId: string; // REQ-GEN-003
  smsType: SmsType; // REQ-GEN-004
  encoding: Encoding; // REQ-GEN-005
  defaultCountry: string; // ISO 3166-1 alpha-2, e.g. "DE" — REQ-GEN-006
  signature: string; // REQ-GEN-008 — appended by default; disabled per message on the send form
  calendarAutomation: boolean; // opt-in to server-side calendar SMS — REQ-CAL
}

export const defaultSettings: LoxSettings = {
  apiKey: "",
  senderId: "",
  smsType: "direct",
  encoding: "gsm7",
  defaultCountry: "DE",
  signature: "",
  calendarAutomation: false,
};

// Built at import time, before a locale exists — so they carry catalogue keys
// and the component resolves them on render.
export const smsTypeOptions: { value: SmsType; labelKey: string }[] = [
  { value: "direct", labelKey: "settings.smsType.direct" },
  { value: "text2speech", labelKey: "settings.smsType.text2speech" },
];

export const encodingOptions: { value: Encoding; labelKey: string }[] = [
  { value: "gsm7", labelKey: "settings.encoding.gsm7" },
  { value: "unicode", labelKey: "settings.encoding.unicode" },
];
